import type { HostingLibraryContext } from '@/core/interfaces/HostingLibraryContext.interface'
import type { LibraryData } from '@/core/types/library.type'

import { normalizeAssemblyName } from './normalizeAssemblyName'

export const buildHostingLibraryContext = (libraryData: LibraryData): HostingLibraryContext => {
  const moduleFullNames = new Set<string>()

  for (const classData of Object.values(libraryData.classes ?? {})) {
    const moduleFullName = classData.moduleFullName?.trim()
    if (moduleFullName) {
      moduleFullNames.add(normalizeAssemblyName(moduleFullName))
    }
  }

  return {
    libraryName: normalizeAssemblyName(libraryData.name),
    moduleFullNames,
  }
}
